import { createSlice } from "@reduxjs/toolkit";
import { nearestCitiesAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const nearestCitiesSlice = createSlice({
  name: "nearestCities",
  initialState: data,
  reducers: {
    nearestCitiesSlice(state) {
      state.isLoading = false;
    },
    nearestCitiesSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    nearestCitiesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    nearestCitiesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const nearestCitiesHandler = () => async (dispatch: any) => {
  try {
    dispatch(nearestCitiesAction.nearestCitiesSlice());
    const response: any = await nearestCitiesAPI();
    dispatch(nearestCitiesAction.nearestCitiesSliceSuccess(response));
  } catch (e: any) {
    dispatch(nearestCitiesAction.nearestCitiesSliceFailure(e?.response?.data?.message));
    dispatch(nearestCitiesAction.nearestCitiesSliceReset());
  }
};
export default nearestCitiesSlice.reducer;
export const nearestCitiesAction = nearestCitiesSlice.actions;
